import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

export default function ApplyFilterButton({
  label,
  onClick,
  sx,
  type = 'button',
  variant = 'contained',
  color = 'primary',
}) {
  const sxDefault = {
    margin: 1,
    ...sx,
  };

  return (
    <Button
      type={type}
      variant={variant}
      color={color}
      onClick={onClick}
      startIcon={<FilterAltIcon />}
      sx={sxDefault}
    >
      {label}
    </Button>
  );
}

ApplyFilterButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
